var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDenture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "denture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "denture"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,23v6a1,1,0,0,1-1,1H24a1,1,0,0,1-1-1V23a4,4,0,0,1,6.83-2.84A4,4,0,0,1,31,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,22.5V28a1,1,0,0,1-1,1H15a1,1,0,0,1-1-1V22.5A3.5,3.5,0,0,1,17.5,19,3.5,3.5,0,0,1,21,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23v4a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V23a3,3,0,1,1,6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,23v6a1,1,0,0,1-1,1H34a1,1,0,0,1-1-1V23a4,4,0,0,1,8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,22.5V28a1,1,0,0,1-1,1H44a1,1,0,0,1-1-1V22.5A3.5,3.5,0,0,1,46.5,19,3.5,3.5,0,0,1,50,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,23v4a1,1,0,0,1-1,1H53a1,1,0,0,1-1-1V23a3,3,0,0,1,6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,35v6a4,4,0,0,1-8,0V35a1,1,0,0,1,1-1h6A1,1,0,0,1,31,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,35v5.5A3.5,3.5,0,0,1,17.5,44,3.5,3.5,0,0,1,14,40.5V35a1,1,0,0,1,1-1h5A1,1,0,0,1,21,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,34v4a3,3,0,0,1-6,0V34a1,1,0,0,1,1-1h4A1,1,0,0,1,12,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,35v6a4,4,0,0,1-6.83,2.84A4,4,0,0,1,33,41V35a1,1,0,0,1,1-1h6A1,1,0,0,1,41,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,35v5.5A3.5,3.5,0,0,1,46.5,44,3.5,3.5,0,0,1,43,40.5V35a1,1,0,0,1,1-1h5A1,1,0,0,1,50,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,34v4a3,3,0,1,1-6,0V34a1,1,0,0,1,1-1h4A1,1,0,0,1,58,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,23.71V23a5,5,0,0,0-8.54-3.53,1.71,1.71,0,0,0-.22.25A5.49,5.49,0,0,0,46.5,17a5.39,5.39,0,0,0-3.88,1.61,5.71,5.71,0,0,0-.74.9,6,6,0,0,0-9.13-.75,6.47,6.47,0,0,0-.75.91,7.27,7.27,0,0,0-.76-.92,6,6,0,0,0-9.12.77,4.5,4.5,0,0,0-.73-.9A5.4,5.4,0,0,0,17.5,17a5.46,5.46,0,0,0-4.73,2.72l-.24-.26A5,5,0,0,0,4,23v.71a1.87,1.87,0,0,1-.85-1.58,1.51,1.51,0,0,1,0-.3A14,14,0,0,1,17,10H47A14,14,0,0,1,60.83,21.83,1.89,1.89,0,0,1,60,23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84,40.18A15,15,0,0,1,46,53H18A15,15,0,0,1,3.16,40.18,1.89,1.89,0,0,1,4,38.29a5,5,0,0,0,8.16,3.57A5.5,5.5,0,0,0,17.5,46a5.39,5.39,0,0,0,3.88-1.61,5.48,5.48,0,0,0,.4-.44,6,6,0,0,0,9.47,1.29,6.47,6.47,0,0,0,.75-.91,7.27,7.27,0,0,0,.76.92A6,6,0,0,0,42.22,44a5.22,5.22,0,0,0,.39.43A5.4,5.4,0,0,0,46.5,46a5.5,5.5,0,0,0,5.32-4.14A5,5,0,0,0,60,38.29,1.87,1.87,0,0,1,60.84,40.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenture);
export default __webpack_public_path__ + "static/media/denture.f2c467cbeed429275dee9c2967c3f21d.svg";
export { ForwardRef as ReactComponent };